import { render, staticRenderFns } from "./FullPageScroll.vue?vue&type=template&id=05d7e076&scoped=true&"
import script from "./FullPageScroll.vue?vue&type=script&lang=ts&"
export * from "./FullPageScroll.vue?vue&type=script&lang=ts&"
import style0 from "./FullPageScroll.vue?vue&type=style&index=0&id=05d7e076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7e076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
